import { useGetTeamMembersQuery } from "../../features/members/TeamMembersApi";
import TeamMember from "./TeamMember";

export default function TeamMemberList() {

	const { data: teamMembers, isLoading, isError } = useGetTeamMembersQuery() || {};
	
	let content = null;
	if (isLoading) {
		content = <div>Loading...</div>;
	}
	else if (!isLoading && isError) {
		content = <div>There was an error!</div>;
	}
	else if (!isLoading && !isError && teamMembers?.length === 0) {
		content = <div>No team members found!</div>;
	}
	else if (!isLoading && !isError && teamMembers?.length > 0) {
		content = teamMembers.map(tm => <TeamMember key={tm.id} member={tm} />);
	}
	else {
		content = <div>Something went wrong!</div>;
	}

	return (
		<div className="mt-8">
			<h3 className="text-xl font-bold">Team Members</h3>
			<div className="mt-3 space-y-4">
				{content}
			</div>
		</div>
	);
}
